function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import ReactHintFactory from "react-hint";
import "react-hint/css/index.css";
import * as EditorContext from "../EditorContext";
import * as OverlayContext from "../OverlayContext";
import Button from "../../Misc/Buttons/DefaultBlueButton";
import Bar from "./Bar";
var ReactHint = ReactHintFactory(React);

function includedBy(origin, compare) {
  var originStart = origin.start;
  var originEnd = originStart + origin.duration;
  var compareStart = compare.start;
  var compareEnd = compareStart + compare.duration;
  return compareStart >= originStart && compareEnd <= originEnd;
}

var TimeRangeSelector = function (_React$Component) {
  _inherits(TimeRangeSelector, _React$Component);

  function TimeRangeSelector() {
    var _temp, _this, _ret;

    _classCallCheck(this, TimeRangeSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.makeRangeClickHandler = function (metadata) {
      return function (e) {
        e.stopPropagation();

        _this.props.EditorContext.video.setCurrentTime(metadata.start);
      };
    }, _this.renderTooltip = function (target) {
      var OverlayContext = _this.props.OverlayContext;

      var interferences = _this.findInterferences(target.dataset.id);

      return React.createElement("div", {
        className: "react-hint__content"
      }, interferences.map(function (overlay) {
        var _overlay$metadata = overlay.metadata,
            id = _overlay$metadata.id,
            start = _overlay$metadata.start,
            duration = _overlay$metadata.duration,
            src = overlay.src,
            text = overlay.text;
        return React.createElement("div", {
          key: id,
          className: "hint-frame"
        }, React.createElement("p", null, "Start: ", start, "s, Duration: ", duration, "s"), src && React.createElement("p", null, React.createElement("img", {
          src: src
        })), text && React.createElement("p", {
          className: "item-text"
        }, text), React.createElement("div", null, React.createElement(Button, {
          onClick: function onClick() {
            return OverlayContext.editItemTimeSettings(id);
          }
        }, "Update"), React.createElement(Button, {
          onClick: function onClick() {
            setTimeout(function () {
              return _this.tooltip.toggleHint();
            });
            OverlayContext.deleteOverlayItem(id);
          }
        }, "Delete")));
      }));
    }, _this.onBarDrag = function (id, position) {
      var _this$props = _this.props,
          OverlayContext = _this$props.OverlayContext,
          EditorContext = _this$props.EditorContext;
      var videoDuration = EditorContext.state.video.props.duration;
      var newStart = (position * videoDuration / window.document.body.clientWidth).toFixed(2) * 1;
      OverlayContext.setOverlayStartPosition(id, newStart);
      EditorContext.video.setCurrentTime(newStart + 0.01);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TimeRangeSelector.prototype.getRangeStyle = function getRangeStyle(metadata) {
    var props = this.props.EditorContext.state.video.props;
    var offset = metadata.start * 100 / props.duration;
    return {
      left: offset + "%",
      width: 5
    };
  };

  TimeRangeSelector.prototype.findInterferences = function findInterferences(id) {
    var overlay = this.props.OverlayContext.state.overlay;
    var overlayObjects = overlay ? overlay.objects : [];
    var selectedOverlay = overlayObjects.find(function (overlayObject) {
      return overlayObject.metadata.id === id;
    });

    if (!selectedOverlay) {
      return [];
    }

    return overlayObjects.filter(function (overlayObject) {
      return includedBy(selectedOverlay.metadata, overlayObject.metadata);
    });
  };

  TimeRangeSelector.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        EditorContext = _props.EditorContext,
        OverlayContext = _props.OverlayContext;
    var video = EditorContext.state.video;
    var overlay = OverlayContext.state.overlay;
    var overlayObjects = overlay ? overlay.objects : [];
    return React.createElement(React.Fragment, null, React.createElement(ReactHint, {
      autoPosition: true,
      events: true,
      persist: true,
      attribute: "data-custom",
      onRenderContent: this.renderTooltip,
      ref: function ref(tooltip) {
        return _this2.tooltip = tooltip;
      }
    }), video.props && React.createElement("div", {
      className: "video-player__controls-track"
    }, overlayObjects.map(function (_ref) {
      var src = _ref.src,
          text = _ref.text,
          metadata = _ref.metadata;
      return React.createElement(Bar, {
        key: metadata.id,
        id: metadata.id,
        start: metadata.start,
        duration: metadata.duration,
        style: _this2.getRangeStyle(metadata),
        onClick: _this2.makeRangeClickHandler(metadata),
        onBeginDrag: function onBeginDrag() {
          return EditorContext.pauseVideo();
        },
        onDrag: _this2.onBarDrag,
        text: text,
        src: src
      });
    })));
  };

  return TimeRangeSelector;
}(React.Component);

TimeRangeSelector.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired,
  OverlayContext: PropTypes.object.isRequired
} : {};
export default EditorContext.consumeContext(OverlayContext.consumeContext(TimeRangeSelector));